import useIntl from '@/utils/intl'
import React, { FunctionComponent, useState } from 'react'
import { useRouter } from 'next/navigation'
import { ServiceCategory } from '@/services/cms-api/service-menu/types'
import { ArrowBack, ArrowForwardIos } from '@mui/icons-material'
import Image from 'next/image'
import { useLanguage } from '@/context/LanguageContext'
import Link from 'next/link'
import DarkIconButton from '../ui/Buttons/SecondaryIconButton'
import { IMG_URL } from '@/utils/constants'
import { GetSearchRes } from '@/services/cms-api/search/types'

interface Prop {
  categories: ServiceCategory[]
  results: GetSearchRes
  onClose: () => void
}
const AppBarMenuMobile: FunctionComponent<Prop> = ({
  categories,
  results,
  onClose
}) => {
  const router = useRouter()
  const [showMenu, setShowMenu] = useState(false)
  const [clicked, setClicked] = React.useState<number>()
  const { locale } = useLanguage()

  const { translate } = useIntl()

  const menus = [
    {
      text: translate('menu.service'),
      action: () => setShowMenu(!showMenu)
    },
    {
      text: translate('menu.news'),
      action: () => {
        router.push('/news')
        onClose()
      }
    },
    {
      text: translate('menu.shop'),
      action: () => {
        router.push('/shop')
        onClose()
      }
    },
    {
      text: '5G',
      action: () => {
        window.open('https://support.mobicom.mn/5g', '_blank')
        onClose()
      }
    }
  ]

  const additionalMenu = [
    {
      name: translate('shop.vatCorp'),
      icon: '/uploads/icons/corp.svg',
      url: 'https://business.mobicom.mn/'
    },
    {
      name: 'Monpay',
      icon: '/uploads/monpay.png',
      url: 'https://monpay.mn/'
    },
    {
      name: 'Voo',
      icon: '/uploads/icons/voo.png',
      url: 'https://voo.mn/'
    }
  ]
  const handleAction = (action: () => void): void => {
    action()
  }
  return (
    <div className='px-4 py-2 flex flex-col lg:hidden'>
      {results.length > 0
        ? (
          <div className='flex flex-col w-full gap-2 pl-2 pr-3 py-2'>
            {results.map((item, i) => (
              <li
                key={i}
                className='flex gap-2 items-center pl-2 pr-3 py-2 hover:bg-[#525252] rounded-lg cursor-pointer'
                onClick={() => router.push(item.link)}
              >
                <span className='text-sm text-textMid font-bold '>
                  {locale === 'en' ? item.titleEn : item.titleMn} -
                </span>
                <span className='text-sm text-textLow'>
                  {locale === 'en' ? item.categoryEn : item.categoryMn}
                </span>
              </li>
            ))}
          </div>
          )
        : (
          <></>
          )}
      <div className='border-t border-[#525252] border-dashed '>
        {showMenu && clicked === undefined
          ? (
            <div className='flex my-1 gap-3'>
              <DarkIconButton
                type='onDark'
                size='sm'
                icon={<ArrowBack />}
                onClick={() => setShowMenu(false)}
              />
              <div className='w-full'>
                {categories.map((item, i) => (
                  <li
                    key={i}
                    className='flex justify-between items-center pl-2 pr-3 py-2 hover:bg-[#525252] rounded-lg cursor-pointer'
                    onClick={() => setClicked(i)}
                  >
                    <div className='flex gap-2 items-center'>
                      <div className='rounded-full border border-textLow p-2'>
                        <Image
                          draggable={false}
                          src={IMG_URL + item.icon}
                          alt='?'
                          width={16}
                          height={16}
                          className='w-4'
                        />
                      </div>
                      <span className='text-sm w-36 font-bold text-textAdditional'>
                        {locale === 'en' ? item.nameEn : item.nameMn}
                      </span>
                    </div>
                    <ArrowForwardIos className='text-xs text-textLow' />
                  </li>
                ))}
              </div>
            </div>
            )
          : showMenu && clicked !== undefined
            ? (
              <div className='flex my-1 gap-3'>
                <DarkIconButton
                  type='onDark'
                  size='sm'
                  icon={<ArrowBack />}
                  onClick={() => setClicked(undefined)}
                />
                <div className='w-full'>
                  {categories[clicked]?.children?.map((item, i) => {
                    return item.link !== null
                      ? (
                        <Link
                          key={i}
                          href={item.link}
                          rel='noopener noreferrer'
                          target='_blank'
                          onClick={onClose}
                        >
                          <li className='py-3 text-textAdditional text-sm font-bold hover:bg-appBar2 rounded-lg cursor-pointer pl-2 my-1 flex justify-between'>
                            {locale === 'en' ? item.nameEn : item.nameMn}
                          </li>
                        </Link>
                        )
                      : (
                        <Link key={i} href={`/service/${item.id}`} onClick={onClose}>
                          <li className='py-3 text-textAdditional text-sm font-bold hover:bg-appBar2 rounded-lg cursor-pointer pl-2 my-1 flex justify-between'>
                            {locale === 'en' ? item.nameEn : item.nameMn}
                          </li>
                        </Link>
                        )
                  })}
                </div>
              </div>
              )
            : (
              <div>
                <ul className='flex flex-col px-2'>
                  {menus.map((menu, i) => (
                    <li
                      key={i}
                      onClick={() => handleAction(menu.action)}
                      className='py-3 text-textAdditional text-sm font-bold hover:bg-appBar2 rounded-lg cursor-pointer pl-2 my-1 flex items-center justify-between'
                    >
                      {menu.text}
                      {i === 0 && <ArrowForwardIos className='text-sm mr-2' />}
                    </li>
                  ))}
                </ul>
                <div className='flex flex-col w-full gap-2 border-t border-[#525252] border-dashed pt-2'>
                  {additionalMenu.map((item, i) => (
                    <Link
                      key={i}
                      href={item.url}
                      rel='noopener noreferrer'
                      target='_blank'
                      onClick={onClose}
                    >
                      <li className='flex gap-2 items-center pl-2 pr-3 py-1 hover:bg-[#525252] rounded-lg cursor-pointer'>
                        <div className='rounded-full border border-textLow p-2 shadow-[inset_0_0_6px_0_rgba(250,250,250,0.36)]'>
                          <Image
                            draggable={false}
                            height={30}
                            width={30}
                            src={IMG_URL + item.icon}
                            alt='?'
                            className='w-5'
                          />
                        </div>
                        <span className='text-sm text-textAdditional font-medium'>
                          {item.name}
                        </span>
                      </li>
                    </Link>
                  ))}
                </div>
              </div>
              )}
      </div>
    </div>
  )
}
export default AppBarMenuMobile
